<template>
    <v-card>
      <v-card-title>
        <span class="headline">Model</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md v-if="!modelItemDesc.query">
            <v-layout wrap>
              <v-flex xs6 v-if="newModel">
                <v-autocomplete :label="labels.vehMake" :items="makeList" v-model="vehModelForm.vehMake" item-text="label" item-value="value" data-vv-name="vehMake" :data-vv-as="labels.vehMake" :error-messages="errors.collect('vehMake')" v-validate="'required'" ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.vehMake}}</v-subheader>
                <div class="title">{{vehModelForm.vehMake}}</div>
              </v-flex>
              <v-flex xs6 v-if="newModel">
                <v-text-field :label="labels.vehModel" v-model="vehModelForm.vehModel" :error-messages="errors.collect('vehModel')" data-vv-name="vehModel" :data-vv-as="labels.vehModel" v-validate="'required|param|max:10'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.vehModel}}</v-subheader>
                <div class="title">{{vehModelForm.vehModel}}</div>
              </v-flex>
              <v-flex>
                <v-text-field :label="labels.vehModelDesc" v-model="vehModelForm.vehModelDesc" :error-messages="errors.collect('vehModelDesc')" data-vv-name="vehModelDesc" :data-vv-as="labels.vehModelDesc" v-validate="'required|entry|max:100'"></v-text-field>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-autocomplete :items="groupList" v-model="vehModelForm.vehGrp" :label="labels.vehGrpDesc" item-text="label" item-value="value" data-vv-name="vehGrpDesc" :data-vv-as="labels.vehGrpDesc" :error-messages="errors.collect('vehGrpDesc')" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-autocomplete :items="permitStatus" v-model="vehModelForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('permitStatus')" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-text-field v-model="vehModelForm.engineCC" :label="labels.engineCC" :error-messages="errors.collect('engineCC')" data-vv-name="engineCC" :data-vv-as="labels.engineCC" v-validate="'integer|max:10|required'"></v-text-field>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-text-field v-model="vehModelForm.tonnage" :label="labels.tonnage" :error-messages="errors.collect('tonnage')" data-vv-name="tonnage" :data-vv-as="labels.tonnage" v-validate="'decimal|max:10|required'"></v-text-field>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-text-field v-model="vehModelForm.noSeats" :label="labels.noSeats" :error-messages="errors.collect('noSeats')" data-vv-name="noSeats" :data-vv-as="labels.noSeats" v-validate="'numeric|max:2|required'"></v-text-field>
              </v-flex>
              <!-- default is String so in use text-field -->
              <v-flex xl6 lg6 xs6>
                <v-text-field v-model="vehModelForm.manufYr" :label="labels.manufYr" :error-messages="errors.collect('manufYr')" data-vv-name="manufYr" :data-vv-as="labels.manufYr" v-validate="'numeric|max:4'"></v-text-field>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-autocomplete :items="bodyTypeList" v-model="vehModelForm.bodyType" :label="labels.bodyType" item-text="label" item-value="value" data-vv-name="bodyType" :data-vv-as="labels.bodyType" :error-messages="errors.collect('bodyType')"></v-autocomplete>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-text-field v-model="vehModelForm.purchasePrice" :label="labels.purchasePrice" :error-messages="errors.collect('purchasePrice')" data-vv-name="purchasePrice" :data-vv-as="labels.inter" v-validate="'decimal|max:7'"></v-text-field>
              </v-flex>
              <v-flex xl6 lg6 xs6>
                <v-text-field v-model="vehModelForm.defPriceUOM" :label="labels.defPriceUOM" :error-messages="errors.collect('defPriceUOM')" data-vv-name="defPriceUOM" :data-vv-as="labels.defPriceUOM" v-validate="'decimal|max:7'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container grid-list-md v-else>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.vehMake}}</v-subheader>
                <div class="title pb-3">{{modelItemDesc.vehMakeDesc}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.vehModel}}</v-subheader>
                <div class="title pb-3">{{vehModelForm.vehModel}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.vehModelDesc}}</v-subheader>
                <div class="subheading pb-3">{{vehModelForm.vehModelDesc}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.vehGrpDesc}}</v-subheader>
                <div class="subheading pb-3">{{modelItemDesc.vehGrpDesc}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.permitStatus}}</v-subheader>
                <div class="subheading pb-3">{{modelItemDesc.permitStatusDesc}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.engineCC}}</v-subheader>
                <div class="subheading pb-3">{{vehModelForm.engineCC}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.tonnage}}</v-subheader>
                <div class="subheading pb-3">{{vehModelForm.tonnage}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.noSeats}}</v-subheader>
                <div class="subheading pb-3">{{vehModelForm.noSeats}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.manufYr}}</v-subheader>
                <div class="subheading pb-3">{{formatNullVal(vehModelForm.manufYr)}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.bodyType}}</v-subheader>
                <div class="subheading pb-3">{{formatNullVal(modelItemDesc.bodyTypeDesc)}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.purchasePrice}}</v-subheader>
                <div class="subheading pb-3">{{formatNullVal(vehModelForm.purchasePrice)}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.defPriceUOM}}</v-subheader>
                <div class="subheading pb-3">{{formatNullVal(vehModelForm.defPriceUOM)}}</div>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave" v-if="!modelItemDesc.query">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  props: {
    'vehModelForm': Object,
    'modelItemDesc': Object,
    'newModel': Boolean
  },
  data() {
    return {
      labels: {
        vehMake: 'Make*',
        vehModel: 'Model Code*',
        vehModelDesc: 'Model Description*',
        bodyType: 'Body Type',
        engineCC: 'Engine CC*',
        tonnage: 'Tonnage*',
        noSeats: 'No. Seats*',
        manufYr: 'Manufacturer Year',
        permitStatus: 'Permit Status*',
        purchasePrice: 'Purchase Price',
        defPriceUOM: 'Default Price UOM',
        vehGrpDesc: 'Vehicle Group*'
      },
      submitting: undefined
    }
  },
  computed: {
    permitStatus() {
      return this.$store.state.vehicle.permitStatus
    },
    bodyTypeList() {
      return this.$store.state.vehicle.bodyTypeList
    },
    makeList() {
      return this.$store.state.vehicle.makeList
    },
    groupList() {
      return this.$store.state.vehicle.groupList
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.vehModelForm.vehMake = undefined
      this.vehModelForm.vehModel = undefined
      this.vehModelForm.vehModelDesc = undefined
      this.vehModelForm.bodyType = undefined
      this.vehModelForm.engineCC = undefined
      this.vehModelForm.tonnage = undefined
      this.vehModelForm.noSeats = undefined
      this.vehModelForm.manufYr = undefined
      this.vehModelForm.permitStatus = undefined
      this.vehModelForm.permitStatusDesc = undefined
      this.vehModelForm.purchasePrice = undefined
      this.vehModelForm.defPriceUOM = undefined
      this.vehModelForm.vehGrp = undefined
      this.modelItemDesc.vehModelDesc = undefined
      this.modelItemDesc.bodyTypeDesc = undefined
      this.modelItemDesc.vehGrpDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newModel) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vehicle.menu.createVehModel
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.vehModelForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vehicle.menu.updateVehModel
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.vehModelForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
